module.exports = __webpack_public_path__ + "img/1F4A4.932b10a5.svg";